/**
 * COMPOSTABLE DOUBLE WALL CUPS - Product Configuration
 * This file handles the product page logic for compostable double wall cups
 * Templates: 8ozA_Double_Wall, 12ozXL_Double_Wall, 16oz_Double_Wall
 */

// Compostable Double Wall Cup Product Functionality
console.log('Product Compostable Double Wall JS loaded');
console.log('Body classes:', document.body.className);

class CompostableDoubleWallProduct {
    constructor() {
    console.log('CompostableDoubleWallProduct initialized');
    
    // State
    this.selectedSize = '8oz';
    this.selectedPrintType = 'Simple';
    this.selectedQuantity = 250;
      this.requireLids = false;
      this.lidColor = 'Black';
    this.isRushed = false;
    this.selectedProductionDays = 10;
    
    // Live pricing cache
    this.productData = null;
    this.currentUnitPrice = 0;
    this._pricingRenderCounter = 0;
    
    // Constants
      this.UNITS_PER_CARTON = 500;
    this.LID_PRICE_HIGH_QTY = 0.099; // 1000+ cups
    this.LID_PRICE_LOW_QTY = 0.099;  // <1000 cups
    this.productionDayOptions = Object.freeze([2, 3, 4, 5, 7, 10]);
    this.productionFeePercentages = Object.freeze({
      10: 0,
      7: 15,
      5: 30,
      4: 40,
      3: 50,
      2: 60
    });
    
    // Sizes that support Full Colour Print
    this.fullColourSizes = ['8oz', '12oz', '16oz'];
      
    // Variant mapping for quantity-based pricing
    // Real variant IDs from Shopify admin (updated to match product with 50664722891034)
    this.variantMapping = {

      "8oz_Simple": {
    "250": "50729030418714",
    "500": "50729030451482",
    "1000": "50729030484250",
    "2000": "50729030517018",
    "3000": "50729030549786",
    "4000": "50729030582554",
    "5000": "50729030615322"
  },
  "8oz_FullColour": {
    "500":  "50729030648090",
    "1000": "50729030680858",
    "2000": "50729030713626",
    "3000": "50729030746394",
    "4000": "50729030779162",
    "5000": "50729030811930",
    "10000":"50729030844698"
  },
  "12oz_Simple": {
    "250":  "50729030877466",
    "500":  "50729030910234",
    "1000": "50729030943002",
    "2000": "50729030975770",
    "3000": "50729031008538",
    "4000": "50729031041306",
    "5000": "50729031074074"
  },
  "12oz_FullColour": {
    "500":  "50729031106842",
    "1000": "50729031139610",
    "2000": "50729031172378",
    "3000": "50729031205146",
    "4000": "50729031237914",
    "5000": "50729031270682",
    "10000":"50729031303450"
  },
  "16oz_Simple": {
    "250":  "50729031336218",
    "500":  "50729031368986",
    "1000": "50729031401754",
    "2000": "50729031434522",
    "3000": "50729031467290",
    "4000": "50729031500058",
    "5000": "50729031532826"
  },
  "16oz_FullColour": {
    "500":  "50729031565594",
    "1000": "50729031598362",
    "2000": "50729031631130",
    "3000": "50729031663898",
    "4000": "50729031696666",
    "5000": "50729031729434",
    "10000":"50729031762202"
      }
    };

    // Lid variant mapping - Updated with correct compostable pulp lid variant IDs
    this.lidVariantMapping = {
      "White": {
        "250": "50731404165402",
        "500": "50731404198170", 
        "1000": "50731404230938",
        "2000": "50731404263706",
        "3000": "50731404296474",
        "4000": "50731404329242",
        "5000": "50731404362010",
        "10000": "50731404394778"
      }
    };
      
      this.init().catch(error => console.error('Initialization error:', error));
    }

    async init() {
    this.setupSizeSelector();
    this.setupPrintTypeSelector();
    this.setupLidsSelector();
    this.setupTurnaroundSelector();
    this.setupFormSubmission();
    this.setupFileUpload();
    this.setupShippingCalculator();
    this.setupDynamicDescription();
    this.setupTooltips();
    this.updatePrintTypeAvailability();
    this.autoSelectMOQQuantity(); // Auto-select MOQ quantity for initial size/print combination
    await this.updatePricingTable();
    this.checkCartAddSuccess();
    this.preventAutoScroll();
  }

  // Auto-select MOQ quantity based on size and print type
  autoSelectMOQQuantity() {
    const pricingKey = this.getPricingKey();
    const variants = this.variantMapping[pricingKey];
    
    if (!variants) return;
    
    // Get the minimum quantity available for this configuration (which is the MOQ)
    const quantities = Object.keys(variants).map(q => parseInt(q)).sort((a, b) => a - b);
    const moqQuantity = quantities[0]; // First (smallest) quantity is the MOQ
    
    console.log(`Auto-selecting MOQ for ${pricingKey}: ${moqQuantity}`);
    
    // Update the selected quantity
    this.selectedQuantity = moqQuantity;
  }
  
  setupSizeSelector() {
    const sizeButtons = document.querySelectorAll('.size-btn');
    console.log('Setting up size selector, found buttons:', sizeButtons.length);
    
    sizeButtons.forEach((btn, index) => {
      btn.addEventListener('click', () => {
        console.log('Size button clicked:', btn.dataset.size);
        
        // Update selection
        sizeButtons.forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
        
        this.selectedSize = btn.dataset.size;
        console.log('Size selected:', this.selectedSize);
        
        this.updatePrintTypeAvailability();
        this.autoSelectMOQQuantity(); // Auto-select MOQ quantity when size changes
        this.updatePricingTable().catch(console.error);
        this.updateDynamicDescription();
        this.updateMediaGalleryForSelectedVariant();
      });
    });
  }
  
  setupPrintTypeSelector() {
    const printButtons = document.querySelectorAll('.print-type-btn');
    console.log('[PrintType Debug] Setting up print type selector, found buttons:', printButtons.length);
    
    printButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.classList.contains('disabled')) {
          return;
        }
        
        // Update selection
        printButtons.forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
        
        this.selectedPrintType = btn.dataset.printType;
        console.log('Print type selected:', this.selectedPrintType);
        
        // Auto-select MOQ quantity based on new print type
        this.autoSelectMOQQuantity();
        
        this.updatePricingTable().catch(console.error);
        this.updateMediaGalleryForSelectedVariant();
      });
    });


  }


  
  setupLidsSelector() {
    const lidsPills = document.querySelectorAll('.lids-pill');
    lidsPills.forEach(pill => {
      pill.addEventListener('click', () => {
        // Update selection
        lidsPills.forEach(p => p.classList.remove('selected'));
        pill.classList.add('selected');
        
        const lidsValue = pill.dataset.lids;
        this.requireLids = lidsValue !== 'no';
        this.lidColor = lidsValue === 'yes-white' ? 'White' : 'Black';
        
        console.log('Lids selected:', lidsValue, 'requireLids:', this.requireLids, 'lidColor:', this.lidColor);
        
      this.updatePricingTable().catch(console.error);
      });
    });
  }
  
  setupTurnaroundSelector() {
    const slider = document.getElementById('production-days-slider');
    const marks = document.querySelectorAll('.production-slider-mark');

    const syncSelection = () => {
      if (!slider) return;

      this.selectedProductionDays = this.getProductionDaysForSliderValue(slider.value);
      this.isRushed = this.getProductionFeePercent() > 0;
      console.log(
        'Production time selected:',
        this.selectedProductionDays,
        'business days',
        'fee:',
        `${this.getProductionFeePercent()}%`
      );

      this.syncProductionTimeUI();
      this.updatePricingTable().catch(console.error);
      this.updateShippingCalculator();
    };

    if (slider) {
      slider.addEventListener('input', syncSelection);
      slider.addEventListener('change', syncSelection);

      if (window.setupProductionSliderDemo) {
        window.setupProductionSliderDemo({ slider, onValueChange: syncSelection });
      }
    }

    marks.forEach(mark => {
      mark.addEventListener('click', () => {
        if (!slider) return;
        this.selectedProductionDays = Number(mark.dataset.days) || 10;
        slider.value = this.getSliderValueForProductionDays(this.selectedProductionDays);
        syncSelection();
      });
    });

    this.syncProductionTimeUI();
  }

  getSliderValueForProductionDays(days) {
    const index = this.productionDayOptions.indexOf(Number(days));
    return index === -1 ? 0 : index;
  }

  getProductionDaysForSliderValue(value) {
    return this.productionDayOptions[Math.round(Number(value))] ?? 10;
  }

  getProductionFeePercent(days = this.selectedProductionDays) {
    return this.productionFeePercentages[Number(days)] ?? 0;
  }

  getProductionFeeMultiplier() {
    return this.getProductionFeePercent() / 100;
  }

  getProductionTimeLabel(days = this.selectedProductionDays) {
    const normalizedDays = Number(days) || 10;
    const dayCount = Number.isFinite(normalizedDays) ? normalizedDays : 10;
    if (dayCount === 10) {
      return 'Standard (10 business days)';
    }
    return `${dayCount} business day${dayCount === 1 ? '' : 's'}`;
  }

  getProductionFeeLabel(days = this.selectedProductionDays) {
    const feePercent = this.getProductionFeePercent(days);
    return feePercent > 0 ? `+${feePercent}% production fee` : 'No production fee';
  }

  getProductionTimePropertyValue() {
    const feePercent = this.getProductionFeePercent();
    return feePercent > 0
      ? `${this.getProductionTimeLabel()} (+${feePercent}% production fee)`
      : this.getProductionTimeLabel();
  }

  syncProductionTimeUI() {
    const slider = document.getElementById('production-days-slider');
    const daysValue = document.getElementById('production-days-value');
    const feeValue = document.getElementById('production-fee-value');
    const rushLabel = document.getElementById('summary-rush-label');
    const feePercent = this.getProductionFeePercent();

    if (daysValue) {
      daysValue.textContent = this.getProductionTimeLabel();
    }

    if (feeValue) {
      feeValue.textContent = this.getProductionFeeLabel();
    }

    if (rushLabel) {
      rushLabel.textContent = feePercent > 0 ? `Production Fee (+${feePercent}%):` : 'Production Fee:';
    }

    if (slider) {
      const progress = (Number(slider.value) / Number(slider.max || 9)) * 100;
      slider.style.setProperty('--production-progress', `${progress}%`);
    }

    document.querySelectorAll('.production-slider-mark').forEach(mark => {
      mark.classList.toggle('is-active', Number(mark.dataset.days) === Number(this.selectedProductionDays));
    });
  }

  setupShippingCalculator() {
    // Initialize the shipping calculator on page load
    this.updateShippingCalculator();
  }

  updateShippingCalculator() {
    const currentDate = new Date();
    const deliveryRangeEl = document.getElementById('delivery-range');
    const orderDateEl = document.getElementById('order-date');
    const shippedDateEl = document.getElementById('shipped-date');
    const doorstepDateEl = document.getElementById('doorstep-date');

    if (!deliveryRangeEl || !orderDateEl || !shippedDateEl || !doorstepDateEl) {
      console.log('Shipping calculator elements not found');
      return;
    }

    const productionDays = Number(this.selectedProductionDays) || 10;
    const minDeliveryDays = productionDays + 1;
    const maxDeliveryDays = productionDays + 3;

    // Calculate dates
    const orderDate = new Date(currentDate);
    const shippedDate = this.addBusinessDays(orderDate, productionDays);
    const doorstepDate = this.addBusinessDays(orderDate, maxDeliveryDays);
    const minDoorstepDate = this.addBusinessDays(orderDate, minDeliveryDays);

    // Format dates
    const formatDate = (date) => {
      const options = { month: 'short', day: 'numeric' };
      const suffix = this.getDateSuffix(date.getDate());
      return date.toLocaleDateString('en-US', options).replace(/\d+/, date.getDate() + suffix);
    };

    const productionTimeText = this.getProductionTimeLabel();

    if (minDeliveryDays === maxDeliveryDays) {
      deliveryRangeEl.textContent = `${productionTimeText} ${formatDate(doorstepDate)}`;
    } else {
      deliveryRangeEl.textContent = `${productionTimeText} ${formatDate(minDoorstepDate)} to ${formatDate(doorstepDate)}`;
    }

    // Update timeline dates
    orderDateEl.textContent = formatDate(orderDate);
    shippedDateEl.textContent = formatDate(shippedDate);
    doorstepDateEl.textContent = formatDate(doorstepDate);
  }

  addBusinessDays(startDate, days) {
    const result = new Date(startDate);
    let addedDays = 0;

    while (addedDays < days) {
      result.setDate(result.getDate() + 1);
      // Skip weekends (Saturday = 6, Sunday = 0)
      if (result.getDay() !== 0 && result.getDay() !== 6) {
        addedDays++;
      }
    }

    return result;
  }

  getDateSuffix(day) {
    if (day >= 11 && day <= 13) {
      return 'th';
    }
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  }

  setupDynamicDescription() {
    // Initialize with default size (8oz)
    this.updateDynamicDescription();
    
    // Setup accordion dropdown functionality (only one open at a time)
    this.setupAccordionBehavior('.dynamic-description'); // Desktop version
    this.setupAccordionBehavior('.dynamic-description-mobile'); // Mobile version
    
    // Auto-open the first tab (Description) on page load
    this.openDescriptionTab();
  }

  openDescriptionTab() {
    // Open description tab on desktop
    const desktopDescriptionTitle = document.querySelector('.dynamic-description .dropdown-title[data-target="description-content"]');
    const desktopDescriptionContent = document.getElementById('description-content');
    
    if (desktopDescriptionTitle && desktopDescriptionContent) {
      desktopDescriptionTitle.classList.add('active');
      desktopDescriptionContent.classList.add('active');
    }
    
    // Open description tab on mobile
    const mobileDescriptionTitle = document.querySelector('.dynamic-description-mobile .dropdown-title[data-target="description-content-mobile"]');
    const mobileDescriptionContent = document.getElementById('description-content-mobile');
    
    if (mobileDescriptionTitle && mobileDescriptionContent) {
      mobileDescriptionTitle.classList.add('active');
      mobileDescriptionContent.classList.add('active');
    }
  }

  setupAccordionBehavior(containerSelector) {
    console.log('Setting up accordion behavior for:', containerSelector);
    const container = document.querySelector(containerSelector);
    if (!container) {
      console.log('Container not found:', containerSelector);
      return;
    }
    
    const dropdownTitles = container.querySelectorAll('.dropdown-title');
    console.log('Found dropdown titles:', dropdownTitles.length);
    
    dropdownTitles.forEach((title, index) => {
      console.log(`Styling dropdown title ${index}:`, title.textContent);
      // Force bold styling directly on the element
      title.style.fontWeight = '700';
      title.style.fontWeight = 'bold';
      title.style.setProperty('font-weight', '700', 'important');
      console.log('Applied styles to:', title.textContent, 'font-weight:', title.style.fontWeight);
      
      title.addEventListener('click', (e) => {
        const targetId = title.getAttribute('data-target');
        const content = document.getElementById(targetId);
        
        if (content) {
          const isCurrentlyActive = title.classList.contains('active');
          
          // Close all dropdowns in this container first
          dropdownTitles.forEach(otherTitle => {
            const otherTargetId = otherTitle.getAttribute('data-target');
            const otherContent = document.getElementById(otherTargetId);
            
            if (otherContent) {
              otherTitle.classList.remove('active');
              otherContent.classList.remove('active');
            }
          });
          
          // If this wasn't active, open it
          if (!isCurrentlyActive) {
            title.classList.add('active');
            content.classList.add('active');
          }
        }
      });
    });
  }

  updateDynamicDescription() {
    const descriptionData = this.getDescriptionData();
    
    console.log('[Double Wall Debug] Updating description for size:', this.selectedSize);
    console.log('[Double Wall Debug] Description data:', descriptionData);
    
    // Update desktop version
    const descriptionContent = document.getElementById('description-content');
    const specificationContent = document.getElementById('specification-content');
    const dielinesContent = document.getElementById('dielines-content');
    const howItWorksContent = document.getElementById('how-it-works-content');
    
    // Update mobile version
    const descriptionContentMobile = document.getElementById('description-content-mobile');
    const specificationContentMobile = document.getElementById('specification-content-mobile');
    const dielinesContentMobile = document.getElementById('dielines-content-mobile');
    const howItWorksContentMobile = document.getElementById('how-it-works-content-mobile');
    
    if (descriptionData) {
      // Update desktop
      if (descriptionContent) {
        descriptionContent.innerHTML = descriptionData.description;
      }
      if (specificationContent) {
        specificationContent.innerHTML = descriptionData.specification;
      }
      if (dielinesContent) {
        dielinesContent.innerHTML = descriptionData.dielines;
      }
      if (howItWorksContent && !howItWorksContent.hasAttribute('data-static-journey')) {
        howItWorksContent.innerHTML = descriptionData.howItWorks;
      }
      
      // Update mobile (same content)
      if (descriptionContentMobile) {
        descriptionContentMobile.innerHTML = descriptionData.description;
      }
      if (specificationContentMobile) {
        specificationContentMobile.innerHTML = descriptionData.specification;
      }
      if (dielinesContentMobile) {
        dielinesContentMobile.innerHTML = descriptionData.dielines;
      }
      if (howItWorksContentMobile && !howItWorksContentMobile.hasAttribute('data-static-journey')) {
        howItWorksContentMobile.innerHTML = descriptionData.howItWorks;
      }
    }
  }

  getDescriptionData() {
    const sizeDescriptions = {
       "8oz": {
         description: `
           <p>Our 8oz (250ml) Compostable Double Wall Cups provide superior heat insulation while being 100% compostable — perfect for hot lattes, cappuccinos, and specialty drinks. Made from FSC-certified paper with aqueous coating and compost-safe inks, eliminating the need for sleeves while maintaining sustainability.</p>
           <p><strong>Available in Simple or Full Colour printing:</strong></p>
           <p>• <strong>Simple:</strong> water-based inks on natural background (MOQ 250 units)<br>
           • <strong>Full Colour:</strong> vibrant compostable ink designs (MOQ 500 units)</p>
           <p><strong>AS 5810 certified compostable.</strong></p>
         `,
         specification: `
           <ul>
             <li><span class="spec-label">Capacity:</span> <span class="spec-value">250ml (8oz)</span></li>
             <li><span class="spec-label">Material:</span> <span class="spec-value">FSC-certified double wall paper</span></li>
             <li><span class="spec-label">Insulation:</span> <span class="spec-value">Compostable double wall construction</span></li>
             <li><span class="spec-label">Lining:</span> <span class="spec-value">Aqueous coating (compostable)</span></li>
             <li><span class="spec-label">Ink:</span> <span class="spec-value">Water-based compost-safe inks</span></li>
             <li><span class="spec-label">Print Type:</span> <span class="spec-value">Simple or Full Colour</span></li>
             <li><span class="spec-label">MOQ:</span> <span class="spec-value">250 units (Simple) / 500 units (Full Colour)</span></li>
             <li><span class="spec-label">Lid Size:</span> <span class="spec-value">Fits 80mm compostable lids</span></li>
             <li><span class="spec-label">Certification:</span> <span class="spec-value">AS 5810 compostable certified</span></li>
             <li><span class="spec-label">Carton Weight:</span> <span class="spec-value">12.4kg</span></li>
           </ul>
         `,
         dielines: `
           <p>Download the template and apply your design:</p>
          <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/8ozA_Double_Wall_Cup_Template_ea30899c-7167-40f1-964e-4b68d177f846.pdf?v=1762386998" class="download-btn" download="8ozA_Double_Wall_Cup_Template.pdf" target="_blank">👉 Download 8oz Double Wall Template</a>
           <p style="margin-top: 1rem; font-size: 0.9rem; color: #64748b;">Need help with templates or setting up your artwork? Get in touch — we're here to make it easy.</p>
         `,
         howItWorks: `
           <div class="process-timeline">
             <div class="process-step">
               <div class="process-number">1</div>
               <div class="process-text"><strong>Confirm Your Order</strong><br>Choose your size and print type, upload artwork, and finalise your order details.</div>
             </div>
             <div class="process-step">
               <div class="process-number">2</div>
               <div class="process-text"><strong>Approve Your Artwork</strong><br>We'll send you a digital mockup for review. Nothing goes to print without your sign-off.</div>
             </div>
             <div class="process-step">
               <div class="process-number">3</div>
               <div class="process-text"><strong>Production Begins</strong><br>Once approved, your custom cups go into production — standard turnaround is 10 business days.</div>
             </div>
             <div class="process-step">
               <div class="process-number">4</div>
               <div class="process-text"><strong>Dispatched & Delivered</strong><br>Your order is packed, shipped via tracked courier, and on its way. We'll email you tracking info once it's out the door.</div>
             </div>
           </div>
         `
       },
       "12oz": {
         description: `
           <p>Our 12oz (395ml) Compostable Double Wall Cups are the perfect sustainable solution for medium-sized hot beverages. Superior heat retention with compostable double-wall insulation — ideal for specialty coffee shops and eco-conscious venues requiring premium service without environmental impact.</p>
           <p><strong>Available in Simple or Full Colour printing:</strong></p>
           <p>• <strong>Simple:</strong> water-based inks on natural background (MOQ 250 units)<br>
           • <strong>Full Colour:</strong> vibrant compostable ink designs (MOQ 500 units)</p>
           <p><strong>AS 5810 certified compostable.</strong></p>
         `,
         specification: `
           <ul>
             <li><span class="spec-label">Capacity:</span> <span class="spec-value">395ml (12oz)</span></li>
             <li><span class="spec-label">Material:</span> <span class="spec-value">FSC-certified double wall paper</span></li>
             <li><span class="spec-label">Insulation:</span> <span class="spec-value">Compostable double wall construction</span></li>
             <li><span class="spec-label">Lining:</span> <span class="spec-value">Aqueous coating (compostable)</span></li>
             <li><span class="spec-label">Ink:</span> <span class="spec-value">Water-based compost-safe inks</span></li>
             <li><span class="spec-label">Print Type:</span> <span class="spec-value">Simple or Full Colour</span></li>
             <li><span class="spec-label">MOQ:</span> <span class="spec-value">250 units (Simple) / 500 units (Full Colour)</span></li>
             <li><span class="spec-label">Lid Size:</span> <span class="spec-value">Fits 90mm compostable lids</span></li>
             <li><span class="spec-label">Certification:</span> <span class="spec-value">AS 5810 compostable certified</span></li>
             <li><span class="spec-label">Carton Weight:</span> <span class="spec-value">15.8kg</span></li>
           </ul>
         `,
         dielines: `
           <p>Download the appropriate dieline template to apply your design:</p>
           <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/12ozXL_Double_Wall_Cup_Template_5489dcae-8e3f-4cd8-819f-5cdc549b2ae2.pdf?v=1762386998" class="download-btn" download="12ozXL_Double_Wall_Cup_Template.pdf" target="_blank">👉 Download 12oz Double Wall Template</a>
           <p style="margin-top: 1rem; font-size: 0.9rem; color: #64748b;">Need help with templates or setting up your artwork? Get in touch — we're here to make it easy.</p>
         `,
         howItWorks: `
           <div class="process-timeline">
             <div class="process-step">
               <div class="process-number">1</div>
               <div class="process-text"><strong>Confirm Your Order</strong><br>Choose your size and print type, upload artwork, and finalise your order details.</div>
             </div>
             <div class="process-step">
               <div class="process-number">2</div>
               <div class="process-text"><strong>Approve Your Artwork</strong><br>We'll send you a digital mockup for review. Nothing goes to print without your sign-off.</div>
             </div>
             <div class="process-step">
               <div class="process-number">3</div>
               <div class="process-text"><strong>Production Begins</strong><br>Once approved, your custom compostable double wall cups go into production — standard turnaround is 10 business days.</div>
             </div>
             <div class="process-step">
               <div class="process-number">4</div>
               <div class="process-text"><strong>Dispatched & Delivered</strong><br>Your order is packed, shipped via tracked courier, and on its way. We'll email you tracking info once it's out the door.</div>
             </div>
           </div>
         `
       },
       "16oz": {
         description: `
           <p>Our 16oz (480ml) Compostable Double Wall Cups are designed for large hot beverages with extended drinking sessions while maintaining complete compostability. Superior insulation keeps drinks hot longer with double-wall construction — perfect for busy eco-conscious cafés and venues serving premium large serves sustainably.</p>
           <p><strong>Available in Simple or Full Colour printing:</strong></p>
           <p>• <strong>Simple:</strong> water-based inks on natural background (MOQ 250 units)<br>
           • <strong>Full Colour:</strong> vibrant compostable ink designs (MOQ 500 units)</p>
           <p><strong>AS 5810 certified compostable.</strong></p>
         `,
         specification: `
           <ul>
             <li><span class="spec-label">Capacity:</span> <span class="spec-value">480ml (16oz)</span></li>
             <li><span class="spec-label">Material:</span> <span class="spec-value">FSC-certified double wall paper</span></li>
             <li><span class="spec-label">Insulation:</span> <span class="spec-value">Compostable double wall construction</span></li>
             <li><span class="spec-label">Lining:</span> <span class="spec-value">Aqueous coating (compostable)</span></li>
             <li><span class="spec-label">Ink:</span> <span class="spec-value">Water-based compost-safe inks</span></li>
             <li><span class="spec-label">Print Type:</span> <span class="spec-value">Simple or Full Colour</span></li>
             <li><span class="spec-label">MOQ:</span> <span class="spec-value">250 units (Simple) / 500 units (Full Colour)</span></li>
             <li><span class="spec-label">Lid Size:</span> <span class="spec-value">Fits 90mm compostable lids</span></li>
             <li><span class="spec-label">Certification:</span> <span class="spec-value">AS 5810 compostable certified</span></li>
             <li><span class="spec-label">Carton Weight:</span> <span class="spec-value">18.2kg</span></li>
           </ul>
         `,
         dielines: `
           <p>Download your dieline to ensure perfect print placement:</p>
           <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/16oz_Double_Wall_Cup_Template_045d62b5-215e-4b46-9715-0ffd0685cc4b.pdf?v=1762386998" class="download-btn" download="16oz_Double_Wall_Cup_Template.pdf" target="_blank">👉 Download 16oz Double Wall Template</a>
           <p style="margin-top: 1rem; font-size: 0.9rem; color: #64748b;">Need help with templates or setting up your artwork? Get in touch — we're here to make it easy.</p>
         `,
         howItWorks: `
           <div class="process-timeline">
             <div class="process-step">
               <div class="process-number">1</div>
               <div class="process-text"><strong>Confirm Your Order</strong><br>Choose your size and print type, upload artwork, and finalise your order details.</div>
             </div>
             <div class="process-step">
               <div class="process-number">2</div>
               <div class="process-text"><strong>Approve Your Artwork</strong><br>We'll send you a digital mockup for review. Nothing goes to print without your sign-off.</div>
             </div>
             <div class="process-step">
               <div class="process-number">3</div>
               <div class="process-text"><strong>Production Begins</strong><br>Once approved, your custom cups go into production — standard turnaround is 10 business days.</div>
             </div>
             <div class="process-step">
               <div class="process-number">4</div>
               <div class="process-text"><strong>Dispatched & Delivered</strong><br>Your order is packed, shipped via tracked courier, and on its way. We'll email you tracking info once it's out the door.</div>
             </div>
           </div>
         `
       }
       // More sizes will be added here
    };
    
    return sizeDescriptions[this.selectedSize] || sizeDescriptions["8oz"];
  }
  
  setupFormSubmission() {
    const customButton = document.getElementById('custom-add-to-cart-btn');
    if (customButton) {
      customButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.addToCart();
      });
    }
  }
  
  setupFileUpload() {
    const fileInput = document.querySelector('input[type="file"][name="properties[Design File]"]');
    if (!fileInput) {
      console.log('File upload input not found');
      return;
    }

    const uploadArea = document.querySelector('div[id^="uploadArea-"]');
    const imagePreview = document.querySelector('img[id^="imagePreview-"]');
    const filePreviewArea = document.querySelector('div[id^="filePreviewArea-"]');
    const fileInfo = document.querySelector('div[id^="fileInfo-"]');
    const fileName = document.querySelector('div[id^="fileName-"]');
    const fileSize = document.querySelector('div[id^="fileSize-"]');
    const removeButton = document.querySelector('button[id^="removeFile-"]');

    // Click handler for upload area
    if (uploadArea) {
      uploadArea.addEventListener('click', () => {
        fileInput.click();
      });

      // Drag and drop handlers
      uploadArea.addEventListener('dragover', (e) => {
        e.preventDefault();
        uploadArea.style.borderColor = '#3b82f6';
        uploadArea.style.backgroundColor = '#eff6ff';
      });

      uploadArea.addEventListener('dragleave', (e) => {
        e.preventDefault();
        uploadArea.style.borderColor = '#cbd5e1';
        uploadArea.style.backgroundColor = '#f8fafc';
      });

      uploadArea.addEventListener('drop', (e) => {
        e.preventDefault();
        uploadArea.style.borderColor = '#cbd5e1';
        uploadArea.style.backgroundColor = '#f8fafc';
        
        const files = e.dataTransfer.files;
        if (files.length) {
          fileInput.files = files;
          this.handleFileSelection(files[0]);
        }
      });
    }

    // File selection handler
    fileInput.addEventListener('change', (e) => {
      const file = e.target.files[0];
      this.handleFileSelection(file);
    });

    // Remove file handler
    if (removeButton) {
      removeButton.addEventListener('click', (e) => {
        e.stopPropagation();
        this.clearFileSelection();
      });
    }
  }

  handleFileSelection(file) {
    const uploadArea = document.querySelector('div[id^="uploadArea-"]');
    const imagePreview = document.querySelector('img[id^="imagePreview-"]');
    const filePreviewArea = document.querySelector('div[id^="filePreviewArea-"]');
    const fileName = document.querySelector('div[id^="fileName-"]');
    const fileSize = document.querySelector('div[id^="fileSize-"]');

    if (!file) {
      this.clearFileSelection();
      return;
    }

    // Validate file size (max 10MB)
    if (file.size > 10 * 1024 * 1024) {
      alert('File size must be less than 10MB');
      this.clearFileSelection();
      return;
    }

    // Hide upload area and show preview
    if (uploadArea) uploadArea.style.display = 'none';
    if (filePreviewArea) filePreviewArea.style.display = 'block';

    // Update file info
    if (fileName) fileName.textContent = file.name;
    if (fileSize) fileSize.textContent = `${(file.size / 1024 / 1024).toFixed(2)}MB`;

    // Show image preview for image files
    if (file.type.startsWith('image/') && imagePreview) {
      const reader = new FileReader();
      reader.onload = (e) => {
        imagePreview.src = e.target.result;
        imagePreview.style.display = 'block';
      };
      reader.readAsDataURL(file);
    } else {
      // Hide image preview for non-image files
      if (imagePreview) imagePreview.style.display = 'none';
    }

    console.log('File selected:', file.name, file.type, file.size);
  }

  clearFileSelection() {
    const fileInput = document.querySelector('input[type="file"][name="properties[Design File]"]');
    const uploadArea = document.querySelector('div[id^="uploadArea-"]');
    const imagePreview = document.querySelector('img[id^="imagePreview-"]');
    const filePreviewArea = document.querySelector('div[id^="filePreviewArea-"]');

    // Clear the file input
    if (fileInput) fileInput.value = '';

    // Show upload area and hide preview
    if (uploadArea) uploadArea.style.display = 'block';
    if (filePreviewArea) filePreviewArea.style.display = 'none';
    if (imagePreview) imagePreview.style.display = 'none';

    console.log('File selection cleared');
  }
  
  updatePrintTypeAvailability() {
    const fullColourBtn = document.getElementById('full-colour-print-btn');
    const unavailableIndicator = fullColourBtn?.querySelector('.unavailable-indicator');
    
    if (fullColourBtn && unavailableIndicator) {
      const isAvailable = this.fullColourSizes.includes(this.selectedSize);
      
      if (isAvailable) {
        fullColourBtn.classList.remove('disabled');
        unavailableIndicator.style.display = 'none';
      } else {
        fullColourBtn.classList.add('disabled');
        unavailableIndicator.style.display = 'inline';
        
        // Switch to Simple Print if Full Colour was selected
        if (this.selectedPrintType === 'FullColour') {
          const simplePrintBtn = document.getElementById('simple-print-btn');
          if (simplePrintBtn) {
            simplePrintBtn.click();
    }
        }
      }
    }
  }
  
  getPricingKey() {
    const printType = this.selectedPrintType === 'FullColour' ? 'FullColour' : 'Simple';
    return `${this.selectedSize}_${printType}`;
  }

  // Helper function to get the appropriate lid quantity based on cup quantity
  getLidQuantityTier(cupQuantity) {
    // Map cup quantities to lid variant quantities (only use quantities that exist in cup variants)
    if (cupQuantity <= 250) return "250";
    if (cupQuantity <= 500) return "500"; 
    if (cupQuantity <= 1000) return "1000";
    if (cupQuantity <= 2000) return "2000";
    if (cupQuantity <= 3000) return "3000";
    if (cupQuantity <= 4000) return "4000";
    if (cupQuantity <= 5000) return "5000";
    if (cupQuantity >= 10000) return "10000";
    return "5000"; // Default fallback for quantities between 5001-9999
    }

  async loadProductData() {
    if (this.productData) return this.productData;
    
    try {
      // First try to get from existing ProductJSON script
      const productScript = document.querySelector(`script[id^="ProductJSON-"]`);
      if (productScript) {
        this.productData = JSON.parse(productScript.textContent);
        console.log('Loaded product data from script:', this.productData.handle);
        return this.productData;
      }
      
      // Fallback: fetch from API using product handle from URL
      const pathParts = window.location.pathname.split('/');
      const handle = pathParts[pathParts.indexOf('products') + 1];
      
      if (handle) {
        const response = await fetch(`/products/${handle}.js`);
        this.productData = await response.json();
        console.log('Loaded product data from API:', this.productData.handle);
        return this.productData;
      }
      
      throw new Error('Could not determine product handle');
    } catch (error) {
      console.error('Failed to load product data:', error);
      return null;
    }
  }

  // Helper: Verify variant matches expected print type
  variantMatchesPrintType(variant, pricingKey) {
    if (!variant) return false;
    const [size, printTypeKey] = pricingKey.split('_');
    const wantedPrint = (printTypeKey === 'FullColour') ? 'full' : 'simple';
    
    const title = (variant.title || '').toString().toLowerCase();
    const o1 = (variant.option1 || '').toString().toLowerCase();
    const o2 = (variant.option2 || '').toString().toLowerCase();
    const o3 = (variant.option3 || '').toString().toLowerCase();
    const blob = `${title} ${o1} ${o2} ${o3}`;
    
    return blob.includes(size.toLowerCase()) && blob.includes(wantedPrint);
  }

  // Heuristic: find a matching variant by options/title when the hard-coded ID
  // is stale or missing. This prefers live Shopify data over fallback pricing.
  findVariantByHeuristic(productData, pricingKey, quantity) {
    if (!productData || !productData.variants) return null;
    const [size, printTypeKey] = pricingKey.split('_');
    const qtyStr = String(quantity);
    const wantedPrint = (printTypeKey === 'FullColour') ? 'full' : 'simple';

    const matches = (v) => {
      const title = (v.title || '').toString().toLowerCase();
      const o1 = (v.option1 || '').toString().toLowerCase();
      const o2 = (v.option2 || '').toString().toLowerCase();
      const o3 = (v.option3 || '').toString().toLowerCase();
      const blob = `${title} ${o1} ${o2} ${o3}`;
      return blob.includes(size.toLowerCase()) &&
             blob.includes(wantedPrint) &&
             blob.includes(qtyStr);
    };

    // Try exact includes first
    let variant = productData.variants.find(matches);
    if (variant) return variant;

    // Loosen: allow qty with commas (e.g., "2,000") or with "x" (e.g., "2000 units")
    const qtyComma = qtyStr.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const matchesLoose = (v) => {
      const title = (v.title || '').toString().toLowerCase();
      const o1 = (v.option1 || '').toString().toLowerCase();
      const o2 = (v.option2 || '').toString().toLowerCase();
      const o3 = (v.option3 || '').toString().toLowerCase();
      const blob = `${title} ${o1} ${o2} ${o3}`;
      return blob.includes(size.toLowerCase()) &&
             blob.includes(wantedPrint) &&
             (blob.includes(qtyComma) || blob.match(new RegExp(`\\b${qtyStr}\\b`)));
    };
    variant = productData.variants.find(matchesLoose);
    return variant || null;
  }

  async updatePricingTable() {
    const tbody = document.getElementById('quantity-grid-body');
    if (!tbody) return;

    // Guard against overlapping async renders
    this._pricingRenderCounter = (this._pricingRenderCounter || 0) + 1;
    const renderId = this._pricingRenderCounter;

    const pricingKey = this.getPricingKey();
    const variants = this.variantMapping[pricingKey];
    
    console.log('Updating pricing for:', pricingKey, variants);
    
    if (!variants) {
      if (renderId !== this._pricingRenderCounter) return;
      tbody.innerHTML = '<tr><td colspan="5" style="text-align: center; padding: 2em;">No pricing available for this configuration</td></tr>';
      return;
    }

    // Load product data to get live pricing
    const productData = await this.loadProductData();
    if (!productData) {
      if (renderId !== this._pricingRenderCounter) return;
      tbody.innerHTML = '<tr><td colspan="5" style="text-align: center; padding: 2em;">Unable to load pricing data</td></tr>';
      return;
    }

    // Check render counter before proceeding
    if (renderId !== this._pricingRenderCounter) return;

    // Clear tbody immediately to prevent duplicate renders (like working version)
    tbody.innerHTML = '';

    // Build pricing data from variants and live Shopify data
    const priceBreaks = [];
    for (const [qty, variantId] of Object.entries(variants)) {
      const quantity = parseInt(qty);
      let variant = productData.variants.find(v => v.id.toString() === variantId);
      
      // CRITICAL: Verify variant matches expected print type - if not, treat as not found
      if (variant && !this.variantMatchesPrintType(variant, pricingKey)) {
        console.warn(`Variant ${variantId} found but doesn't match print type ${pricingKey}, searching for correct variant`);
        variant = null;
      }
      
      if (variant) {
        // Handle both string and cents pricing from Shopify
        let price = variant.price;
        if (typeof price === 'string') {
          price = parseFloat(price);
        } else if (price > 100) {
          // Convert from cents to dollars
          price = price / 100;
        }
        
        const unitPrice = price / quantity;
        this.currentUnitPrice = unitPrice; // Cache for calculations
        
        priceBreaks.push({
          qty: quantity,
          price: unitPrice,
          variantPrice: price,
          variantId: variantId
        });
      } else {
        // Try to locate the correct variant by options/title before falling back
        const guessed = this.findVariantByHeuristic(productData, pricingKey, quantity);
        if (guessed) {
          let price = guessed.price;
          if (typeof price === 'string') {
            price = parseFloat(price);
          } else if (price > 100) {
            price = price / 100;
          }
          const unitPrice = price / quantity;
          this.currentUnitPrice = unitPrice;
          // Optimistically patch in-memory mapping so subsequent lookups are fast
          this.variantMapping[pricingKey][qty] = guessed.id.toString();
          priceBreaks.push({
            qty: quantity,
            price: unitPrice,
            variantPrice: price,
            variantId: guessed.id.toString()
          });
        } else {
          // Fallback pricing for missing variants
          const fallbackPrice = this.getFallbackPrice(quantity, pricingKey);
          console.warn(`Variant ${variantId} not found, using fallback price: $${fallbackPrice}`);
          priceBreaks.push({
            qty: quantity,
            price: fallbackPrice,
            variantPrice: quantity * fallbackPrice,
            variantId: variantId
          });
        }
      }
    }

    // Sort by quantity
    priceBreaks.sort((a, b) => a.qty - b.qty);

    // If a newer render started while building, abort to avoid double rows
    if (renderId !== this._pricingRenderCounter) return;

    // Use document fragment for efficient DOM manipulation
    const frag = document.createDocumentFragment();

    priceBreaks.forEach((breakpoint, index) => {
      const row = document.createElement('tr');
      row.classList.add('quantity-row');
      row.dataset.quantity = breakpoint.qty;
      
      // Make entire row clickable
      row.addEventListener('click', () => {
        // Find and check the radio button
        const radio = row.querySelector('input[type="radio"]');
        if (radio) {
          radio.checked = true;
          this.selectedQuantity = breakpoint.qty;
          this.updateRowSelection();
          this.updateSelectedQuantityDisplay();
          this.updateMediaGalleryForSelectedVariant();
        }
      });
      
      // Radio button
      const radioCell = document.createElement('td');
      const radio = document.createElement('input');
      radio.type = 'radio';
      radio.name = 'quantity_selection';
      radio.value = breakpoint.qty;
      radio.addEventListener('change', () => {
        if (radio.checked) {
          this.selectedQuantity = breakpoint.qty;
          this.updateRowSelection();
          this.updateSelectedQuantityDisplay();
          this.updateMediaGalleryForSelectedVariant();
        }
      });
      
      // Pre-select first option or maintain current selection
      if ((index === 0 && this.selectedQuantity === null) || breakpoint.qty === this.selectedQuantity) {
        radio.checked = true;
        this.selectedQuantity = breakpoint.qty;
        row.classList.add('selected');
      }
      
      radioCell.appendChild(radio);
      row.appendChild(radioCell);
        
      // Quantity
      const qtyCell = document.createElement('td');
      qtyCell.textContent = breakpoint.qty.toLocaleString();
      row.appendChild(qtyCell);

      // Cartons
        const cartonsCell = document.createElement('td');
      const cartons = breakpoint.qty / this.UNITS_PER_CARTON;
      cartonsCell.textContent = this.decimalToFraction(cartons);
        row.appendChild(cartonsCell);

      // Unit Price with membership pricing
      const unitPriceCell = document.createElement('td');
      
      // Check for membership pricing
      const customerTags = document.body.dataset.customerTags || '';
      const tags = customerTags.toLowerCase().split(',').map(tag => tag.trim());
      let memberTier = null;
      let discountPercent = 0;
      
      if (window.MembershipPricing) {
        memberTier = window.MembershipPricing.getCustomerTier();
        discountPercent = window.MembershipPricing.getDiscountPercent();
      } else {
        // Fallback to legacy logic for bronze/silver/gold/trade
        if (tags.includes('trade')) {
          memberTier = 'trade';
          discountPercent = 20;
        } else if (tags.includes('gold')) {
          memberTier = 'gold';
          discountPercent = 15;
        } else if (tags.includes('silver')) {
          memberTier = 'silver';
          discountPercent = 10;
        } else if (tags.includes('bronze')) {
          memberTier = 'bronze';
          discountPercent = 5;
        }
      }
      
      if (memberTier && discountPercent > 0) {
        const discountedUnitPrice = breakpoint.price * (1 - discountPercent / 100);
        console.log(`[Membership Debug] Unit Price - Original: $${breakpoint.price.toFixed(2)}, Discounted: $${discountedUnitPrice.toFixed(2)}, Tier: ${memberTier}`);
        
        unitPriceCell.innerHTML = `
          <span class="original-price">$${breakpoint.price.toFixed(2)}</span>
          <span class="member-price member-${memberTier}">$${discountedUnitPrice.toFixed(2)}</span>
          <span class="membership-badge membership-${memberTier}">${memberTier === 'trade' ? '💎' : memberTier === 'gold' ? '🥇' : memberTier === 'silver' ? '🥈' : '🥉'}</span>
        `;
      } else {
        unitPriceCell.textContent = `$${breakpoint.price.toFixed(2)}`;
      }
      row.appendChild(unitPriceCell);

      // Total Price with membership discount (base only, no lids or rush)
      const totalCell = document.createElement('td');
      let baseTotal = breakpoint.qty * breakpoint.price;
      
      if (memberTier && discountPercent > 0) {
        const discountedTotal = baseTotal * (1 - discountPercent / 100);
        totalCell.innerHTML = `
          <span class="original-price">$${baseTotal.toFixed(2)}</span>
          <span class="member-price member-${memberTier}">$${discountedTotal.toFixed(2)}</span>
        `;
      } else {
        totalCell.textContent = `$${baseTotal.toFixed(2)}`;
      }
      row.appendChild(totalCell);

      frag.appendChild(row);
    });

    // Final check: If a newer render started while building, abort to avoid double rows
    if (renderId !== this._pricingRenderCounter) return;

    // Append fragment (tbody.innerHTML already cleared earlier)
    tbody.appendChild(frag);

    this.updateRowSelection();
    this.updateSelectedQuantityDisplay();
    }

  getFallbackPrice(quantity, pricingKey) {
    // Fallback pricing based on quantity tiers and product type
    const [size, printType] = pricingKey.split('_');
    
    // Base rates per unit for compostable double wall
    let baseRate = 0.60; // Default base rate for compostable double wall
    
    // Size adjustments
    if (size === '8oz') baseRate = 0.55;
    else if (size === '12oz') baseRate = 0.65;
    else if (size === '16oz') baseRate = 0.75;
    
    // Print type adjustments
    if (printType === 'FullColour') baseRate *= 1.3;
    
    // Quantity tier discounts
    if (quantity >= 10000) baseRate *= 0.6;
    else if (quantity >= 5000) baseRate *= 0.7;
    else if (quantity >= 4000) baseRate *= 0.75;
    else if (quantity >= 3000) baseRate *= 0.8;
    else if (quantity >= 2000) baseRate *= 0.85;
    else if (quantity >= 1000) baseRate *= 0.9;
    else if (quantity >= 500) baseRate *= 0.95;
    
    return baseRate;
  }

  updateRowSelection() {
    // Remove selection from all rows
    document.querySelectorAll('.quantity-row').forEach(row => {
      row.classList.remove('selected');
    });
    
    // Add selection to current row
    if (this.selectedQuantity) {
      const selectedRow = document.querySelector(`[data-quantity="${this.selectedQuantity}"]`);
      if (selectedRow) {
        selectedRow.classList.add('selected');
      }
    }
  }
  
  updateSelectedQuantityDisplay() {
    // Update any selected quantity display elements
    const selectedQtyElements = document.querySelectorAll('.selected-quantity-display');
    selectedQtyElements.forEach(el => {
      el.textContent = this.selectedQuantity ? this.selectedQuantity.toLocaleString() : '';
    });
    
    // Update order summary
    this.updateOrderSummary();
  }
  
  updateOrderSummary() {
    if (!this.selectedQuantity) return;
    
    // Use cached unit price from live data
    let unitPrice = this.calculateUnitPrice();
    const variantTotalPrice = this.calculateVariantTotalPrice();
    
    if (!unitPrice) return;
    let lidPrice = 0;
    let rushFee = 0;
    let totalPrice = variantTotalPrice;

    // Membership discount detection
    const customerTags = document.body.dataset.customerTags || '';
    const tags = customerTags.toLowerCase().split(',').map(tag => tag.trim());
    let memberTier = null;
    let memberDiscountPercent = 0;
    if (window.MembershipPricing) {
      memberTier = window.MembershipPricing.getCustomerTier();
      memberDiscountPercent = window.MembershipPricing.getDiscountPercent();
    } else {
      if (tags.includes('trade')) { memberTier = 'trade'; memberDiscountPercent = 20; }
      else if (tags.includes('gold')) { memberTier = 'gold'; memberDiscountPercent = 15; }
      else if (tags.includes('silver')) { memberTier = 'silver'; memberDiscountPercent = 10; }
      else if (tags.includes('bronze')) { memberTier = 'bronze'; memberDiscountPercent = 5; }
    }

    // Add lids cost (for display purposes)
    if (this.requireLids) {
      // Check if we're using lid-inclusive pricing (8oz 10,000 quantity)
      const useLidInclusiveVariant = (this.selectedQuantity === 10000 && this.selectedSize === '8oz');
      
      if (useLidInclusiveVariant) {
        // Lids are included in the unit price, so no separate lid cost
        lidPrice = 0;
        document.getElementById('summary-lid-row').style.display = 'none';
        document.getElementById('summary-lid-price').textContent = '$0.00';
      } else {
        // Calculate separate lid pricing
        const lidUnitPrice = this.selectedQuantity >= 1000 ? this.LID_PRICE_HIGH_QTY : this.LID_PRICE_LOW_QTY;
        let originalLidPrice = this.selectedQuantity * lidUnitPrice;
        lidPrice = originalLidPrice;
        if (memberDiscountPercent > 0) {
          lidPrice = lidPrice * (1 - memberDiscountPercent / 100);
        }
        totalPrice += lidPrice;
        unitPrice += lidUnitPrice;
        document.getElementById('summary-lid-row').style.display = '';
        if (memberDiscountPercent > 0) {
          document.getElementById('summary-lid-price').innerHTML = `
            <span class="original-price">$${originalLidPrice.toFixed(2)}</span>
            <span class="member-price member-${memberTier}">$${lidPrice.toFixed(2)}</span>
          `;
        } else {
          document.getElementById('summary-lid-price').textContent = `$${lidPrice.toFixed(2)}`;
        }
      }
    } else {
      document.getElementById('summary-lid-row').style.display = 'none';
      document.getElementById('summary-lid-price').textContent = '$0.00';
    }

    const productionFeePercent = this.getProductionFeePercent();
    const productionFeeMultiplier = this.getProductionFeeMultiplier();

    if (productionFeePercent > 0) {
      const baseCupTotal = variantTotalPrice;
      if (memberDiscountPercent > 0) {
        const discountedBase = baseCupTotal * (1 - memberDiscountPercent / 100);
        rushFee = discountedBase * productionFeeMultiplier;
        const originalRush = Math.round(baseCupTotal * productionFeeMultiplier);
        document.getElementById('summary-rush-row').style.display = '';
        document.getElementById('summary-rush-fee').innerHTML = `
          <span class="original-price">$${originalRush.toFixed(2)}</span>
          <span class="member-price member-${memberTier}">$${rushFee.toFixed(2)}</span>
        `;
      } else {
        rushFee = Math.round(baseCupTotal * productionFeeMultiplier);
        document.getElementById('summary-rush-row').style.display = '';
        document.getElementById('summary-rush-fee').textContent = `$${rushFee.toFixed(2)}`;
      }
      totalPrice += rushFee;
    } else {
      document.getElementById('summary-rush-row').style.display = 'none';
      document.getElementById('summary-rush-fee').textContent = '$0.00';
    }

    // Update summary elements
    const summaryQuantity = document.getElementById('summary-quantity');
    const summaryUnitPrice = document.getElementById('summary-unit-price');
    const summaryTotal = document.getElementById('summary-total');
    
    if (summaryQuantity) summaryQuantity.textContent = this.selectedQuantity.toLocaleString();
    
    if (summaryUnitPrice) {
      if (memberDiscountPercent > 0) {
        const discountedUnitPrice = unitPrice * (1 - memberDiscountPercent / 100);
        summaryUnitPrice.innerHTML = `
          <span class="original-price">$${unitPrice.toFixed(2)}</span>
          <span class="member-price member-${memberTier}">$${discountedUnitPrice.toFixed(2)}</span>
        `;
      } else {
        summaryUnitPrice.textContent = `$${unitPrice.toFixed(2)}`;
      }
    }
    
    if (summaryTotal) {
      if (memberDiscountPercent > 0) {
        const originalCupTotal = variantTotalPrice;
        const originalLidPrice = this.requireLids ? (this.selectedQuantity * (this.selectedQuantity >= 1000 ? this.LID_PRICE_HIGH_QTY : this.LID_PRICE_LOW_QTY)) : 0;
        const originalRushFee = productionFeePercent > 0 ? Math.round(originalCupTotal * productionFeeMultiplier) : 0;
        const originalSubtotal = originalCupTotal + originalLidPrice + originalRushFee;
        const discountedCup = originalCupTotal * (1 - memberDiscountPercent / 100);
        const discountedLid = originalLidPrice * (1 - memberDiscountPercent / 100);
        const discountedRush = productionFeePercent > 0 ? (discountedCup * productionFeeMultiplier) : 0;
        const computedTotal = discountedCup + discountedLid + discountedRush;
        const totalSavings = originalSubtotal - computedTotal;
        summaryTotal.innerHTML = `
          <span class="original-price">$${originalSubtotal.toFixed(2)}</span>
          <span class="member-price member-${memberTier}">$${computedTotal.toFixed(2)}</span>
        `;
        const discountRow = document.getElementById('summary-discount-row');
        const discountLabel = document.getElementById('summary-discount-label');
        const discountAmountEl = document.getElementById('summary-discount-amount');
        if (discountRow && discountLabel && discountAmountEl) {
          discountRow.style.display = 'flex';
          discountLabel.textContent = `${memberTier.toUpperCase()} Member Discount (${memberDiscountPercent}%):`;
          discountAmountEl.textContent = `-$${totalSavings.toFixed(2)}`;
          discountAmountEl.style.color = '#28a745';
          discountAmountEl.style.fontWeight = '600';
        }
      } else {
        summaryTotal.textContent = `$${totalPrice.toFixed(2)}`;
        const discountRow = document.getElementById('summary-discount-row');
        if (discountRow) discountRow.style.display = 'none';
      }
    }
  }

  async addToCart() {
    const button = document.getElementById('custom-add-to-cart-btn');
    if (!button) return;

    // Validate that a design file is uploaded
    const fileInput = document.querySelector('input[type="file"][name="properties[Design File]"]');
    // File upload is now optional, so skip this check

    // Show loading state
    button.classList.add('loading');
    button.disabled = true;

    try {
      // Get the correct variant ID based on size, print type, and quantity
      const pricingKey = this.getPricingKey();
      const quantityKey = String(this.selectedQuantity);
      
      // Check if we should use lid-inclusive variant (10,000 quantity + 8oz + lids selected)
      let variantId;
      let useLidInclusiveVariant = false;
      
      if (this.requireLids && this.selectedQuantity === 10000 && this.selectedSize === '8oz') {
        // For 8oz 10,000 quantity with lids, use the lid-inclusive variant
        const lidQuantityTier = this.getLidQuantityTier(this.selectedQuantity);
        const lidVariantId = this.lidVariantMapping[this.lidColor]?.[lidQuantityTier];
        
        if (lidVariantId) {
          variantId = lidVariantId;
          useLidInclusiveVariant = true;
          console.log('[AddToCart Debug] Using lid-inclusive variant for 8oz 10000:', variantId);
        } else {
          // Fallback to regular variant if lid variant not found
          variantId = this.variantMapping[pricingKey]?.[quantityKey];
        }
      } else {
        // Use regular variant
        variantId = this.variantMapping[pricingKey]?.[quantityKey];
      }
      
      // Verify variant matches expected print type
      if (variantId && this.productData) {
        const variant = this.productData.variants.find(v => v.id.toString() === variantId);
        if (variant && !this.variantMatchesPrintType(variant, pricingKey)) {
          console.warn(`Variant ${variantId} doesn't match print type ${pricingKey}, searching for correct variant`);
          const correctVariant = this.findVariantByHeuristic(this.productData, pricingKey, this.selectedQuantity);
          if (correctVariant) {
            variantId = correctVariant.id.toString();
            console.log('[AddToCart Debug] Using corrected variant ID:', variantId);
          }
        }
      }
      
      console.log('[AddToCart Debug] Selected variant ID:', variantId);
      
      if (!variantId) {
        throw new Error(`No variant found for ${pricingKey} - ${quantityKey} units.`);
      }

      // Create FormData to handle file upload
      const formData = new FormData();

      // Shared group id so the cup, its lids and its rush fee stay linked in the cart
      // (cart grouping + add-on panel + rush removal all key off _epk_group). Without this
      // the rush fee renders as a separate, unlinked card.
      const epkGroup = 'epkorder-' + Date.now().toString(36) + '-' + Math.floor(Math.random() * 1000000).toString(36);

      // Add the main cup variant (or lid-inclusive variant)
      formData.append('items[0][id]', variantId);
      formData.append('items[0][quantity]', '1');
      formData.append('items[0][properties][Size]', this.selectedSize);
      formData.append('items[0][properties][Print Type]', this.selectedPrintType);
      formData.append('items[0][properties][Quantity]', this.selectedQuantity);
      formData.append('items[0][properties][Price/Unit]', `$${this.calculateUnitPrice().toFixed(2)}`);
      formData.append('items[0][properties][Production Time]', this.getProductionTimePropertyValue());
      formData.append('items[0][properties][_epk_group]', epkGroup);
      
      if (useLidInclusiveVariant) {
        formData.append('items[0][properties][Includes Lids]', `${this.lidColor} lids included`);
      }
      
      // Add the uploaded file
      if (fileInput.files[0]) {
        formData.append('items[0][properties][Design File]', fileInput.files[0]);
      }

      let itemIndex = 1; // Start next items at index 1

      // Add separate lid variant if lids are required AND we didn't use lid-inclusive variant
      if (this.requireLids && !useLidInclusiveVariant) {
        const lidQuantityTier = this.getLidQuantityTier(this.selectedQuantity);
        const lidVariantId = this.lidVariantMapping[this.lidColor]?.[lidQuantityTier];
        
        if (lidVariantId) {
          formData.append(`items[${itemIndex}][id]`, lidVariantId);
          formData.append(`items[${itemIndex}][quantity]`, '1');
          formData.append(`items[${itemIndex}][properties][Type]`, 'Lids');
          formData.append(`items[${itemIndex}][properties][Color]`, this.lidColor);
          formData.append(`items[${itemIndex}][properties][Quantity]`, String(this.selectedQuantity));
          formData.append(`items[${itemIndex}][properties][For Cup Size]`, this.selectedSize);
          formData.append(`items[${itemIndex}][properties][_epk_group]`, epkGroup);
          itemIndex++;
        }
      }

      const productionFeePercent = this.getProductionFeePercent();

      if (productionFeePercent > 0) {
        const variantTotalPrice = this.calculateVariantTotalPrice();
        const rushFeeAmount = variantTotalPrice * (productionFeePercent / 100);
        const rushFeeQuantity = Math.round(rushFeeAmount);
        
        formData.append(`items[${itemIndex}][id]`, '50675778126106');
        formData.append(`items[${itemIndex}][quantity]`, rushFeeQuantity);
        formData.append(`items[${itemIndex}][properties][Base Order Total]`, `$${variantTotalPrice.toFixed(2)}`);
        formData.append(`items[${itemIndex}][properties][Production Time]`, this.getProductionTimeLabel());
        formData.append(
          `items[${itemIndex}][properties][Production Fee (${this.getProductionTimeLabel()}) +${productionFeePercent}%]`,
          `$${rushFeeAmount.toFixed(2)}`
        );
        formData.append(`items[${itemIndex}][properties][_epk_group]`, epkGroup);
      }

      // Submit to cart using FormData (supports file uploads)
      const response = await fetch('/cart/add', {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to add to cart: ${response.status} - ${errorText}`);
      }

      // Success
      document.dispatchEvent(new CustomEvent('cart:updated'));
      // Set flag for success state after page refresh
      localStorage.setItem('cartAddSuccess', 'true');
      // Reload page to update cart UI (since we're using form submission)
      setTimeout(() => {
        window.location.reload();
      }, 1000);

    } catch (error) {
      console.error('Cart error:', error);
      this.showMessage(`Error adding to cart: ${error.message}`, 'error');
    } finally {
      button.classList.remove('loading');
      button.disabled = false;
    }
  }
  
  // Helper method to calculate unit price
  calculateUnitPrice() {
    // Return cached unit price from live pricing data
    return this.currentUnitPrice || 0;
  }

  // Helper method to calculate variant total price
  calculateVariantTotalPrice() {
    // Use live Shopify pricing - variant price is the total for the quantity
    const pricingKey = this.getPricingKey();
    const variants = this.variantMapping[pricingKey];
    let variantId = variants?.[String(this.selectedQuantity)];
    
    if (this.productData) {
      // Resolve variant: if mapping is stale, try heuristic
      let variant = null;
      if (variantId) {
        variant = this.productData.variants.find(v => v.id.toString() === variantId);
        // Verify variant matches expected print type
        if (variant && !this.variantMatchesPrintType(variant, pricingKey)) {
          console.warn(`Variant ${variantId} doesn't match print type ${pricingKey}, searching for correct variant`);
          variant = null;
        }
      }
      if (!variant) {
        variant = this.findVariantByHeuristic(this.productData, pricingKey, this.selectedQuantity);
        if (variant) {
          variantId = variant.id.toString();
          if (variants) variants[String(this.selectedQuantity)] = variantId;
        }
      }
      
      if (variant) {
        let price = variant.price;
        if (typeof price === 'string') {
          price = parseFloat(price);
        } else if (price > 100) {
          price = price / 100;
        }
        return price;
      }
    }
    
    // Fallback calculation
    const unitPrice = this.calculateUnitPrice();
    const totalPrice = unitPrice * this.selectedQuantity;
    
    console.log(`[VariantTotalPrice] Unit: $${unitPrice}, Qty: ${this.selectedQuantity}, Total: $${totalPrice}`);
    
    return totalPrice;
  }
  
  showMessage(text, type) {
    console.log('showMessage called:', text, type);
    
    // Remove existing messages
    const existingMessages = document.querySelectorAll('.cup-message');
    existingMessages.forEach(msg => msg.remove());
    
    // Create new toast message
    const message = document.createElement('div');
    message.className = `cup-message cup-${type}-message cup-toast-message`;
    message.textContent = text;
    
    // Position the toast near the Add to cart button
    const addToCartButton = document.querySelector('#custom-add-to-cart-btn') || 
                           document.querySelector('.custom-add-to-cart-button') ||
                           document.querySelector('.product-form-double-wall__cart-submit') || 
                           document.querySelector('#product-form-double-wall button[type="submit"]') ||
                           document.querySelector('button[name="add"]');
    
    console.log('Found button:', addToCartButton);
    
    if (addToCartButton) {
      const buttonRect = addToCartButton.getBoundingClientRect();
      console.log('Button rect:', buttonRect);
      
      // Position the toast near the button
      message.style.position = 'fixed';
      message.style.top = `${buttonRect.top + (buttonRect.height / 2) - 30}px`;
      message.style.right = '20px';
      message.style.zIndex = '9999';
      
      document.body.appendChild(message);
      console.log('Toast appended to body');
      
      // Trigger slide-in animation
      setTimeout(() => {
        message.classList.add('show');
        console.log('Toast show class added');
      }, 10);
      
      // Auto-remove after 3 seconds
      setTimeout(() => {
        message.classList.add('hide');
      setTimeout(() => {
        message.remove();
          console.log('Toast removed');
        }, 300); // Allow fade-out animation to complete
      }, 3000);
    } else {
      console.warn('Add to cart button not found, falling back to simple display');
      // Fallback: just append to body with default positioning
      message.style.position = 'fixed';
      message.style.top = '20px';
      message.style.right = '20px';
      message.style.zIndex = '9999';
      
      document.body.appendChild(message);
      
      setTimeout(() => {
        message.classList.add('show');
      }, 10);
      
      setTimeout(() => {
        message.classList.add('hide');
        setTimeout(() => {
          message.remove();
        }, 300);
      }, 3000);
    }
  }
  
  // Smart number formatting - only show decimals if needed, max 2 decimals
  formatNumber(number) {
    const rounded = Math.round(number * 100) / 100; // Round to 2 decimal places
    return rounded % 1 === 0 ? rounded.toString() : rounded.toFixed(2);
  }

  // Helper function to convert decimal to fraction
  decimalToFraction(decimal) {
    if (decimal >= 1) {
      return this.formatNumber(decimal);
    }
    
    // Common fractions for carton sizes
    const fractions = {
      0.25: '1/4',
      0.5: '1/2',
      0.75: '3/4'
    };
    
    return fractions[decimal] || this.formatNumber(decimal);
    }

  updateMediaGalleryForSelectedVariant() {
    // Get the correct variant ID based on current selections
    const pricingKey = this.getPricingKey();
    const quantityKey = String(this.selectedQuantity);
    let variantId = this.variantMapping[pricingKey]?.[quantityKey];
    
    // Verify variant matches expected print type
    if (variantId && this.productData) {
      const variant = this.productData.variants.find(v => v.id.toString() === variantId);
      if (variant && !this.variantMatchesPrintType(variant, pricingKey)) {
        console.warn(`Variant ${variantId} doesn't match print type ${pricingKey}, searching for correct variant`);
        variantId = null;
      }
    }
    
    if (!variantId && this.productData) {
      const guessed = this.findVariantByHeuristic(this.productData, pricingKey, this.selectedQuantity);
      if (guessed) {
        variantId = guessed.id.toString();
        if (this.variantMapping[pricingKey]) this.variantMapping[pricingKey][quantityKey] = variantId;
      }
    }
    
    if (!variantId) {
      console.log('No variant ID found for:', pricingKey, quantityKey);
      return;
    }

    console.log('Updating for variant ID:', variantId);
    
    // Update variant ID input
    const variantIdInputs = document.querySelectorAll('input[name="id"]');
    variantIdInputs.forEach(input => {
      input.value = variantId;
      console.log('Updated variant input to:', variantId);
    });

    // Update URL
    const currentUrl = new URL(window.location);
    currentUrl.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', currentUrl.toString());
    console.log('Updated URL variant to:', variantId);
    
    // Find the variant's featured media and switch to it
    this.switchToVariantMedia(variantId);
    
    // Trigger a change event on the variant input to let Shopify know
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput) {
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  
  switchToVariantMedia(variantId) {
    try {
      // Get product data
      const productScript = document.querySelector(`script[id^="ProductJSON-"]`);
      if (!productScript) {
        console.log('No product data script found');
        return;
      }
      
      const productData = JSON.parse(productScript.textContent);
      const variant = productData.variants?.find(v => v.id == variantId);
      
      if (!variant || !variant.featured_media?.id) {
        console.log('No variant or featured media found for:', variantId);
        return;
      }
      
      console.log('Switching to media ID:', variant.featured_media.id, 'for variant:', variant.title);
      
      // Find the media gallery component
      const mediaGallery = document.querySelector('media-gallery');
      if (!mediaGallery) {
        console.log('Media gallery component not found');
        return;
      }
      
      // Get the section ID from the media gallery
      const sectionId = mediaGallery.dataset.sectionId;
      const targetMediaId = `${sectionId}-${variant.featured_media.id}`;
      
      console.log('Looking for media with ID:', targetMediaId);
      
      // Find the thumbnail with the matching data-target
      const thumbnail = document.querySelector(`[data-target="${targetMediaId}"]`);
      if (thumbnail) {
        const button = thumbnail.querySelector('button');
        if (button) {
          console.log('Found thumbnail button, clicking it');
          button.click();
          return;
        }
      }
      
      // Fallback: directly call setActiveMedia if thumbnail click didn't work
      console.log('Thumbnail not found, using direct media switching');
      if (mediaGallery.setActiveMedia) {
        mediaGallery.setActiveMedia(targetMediaId, false);
      } else {
        // Manual fallback
        this.manualMediaSwitch(targetMediaId);
      }
      
    } catch (error) {
      console.error('Error switching variant media:', error);
    }
  }
  
  manualMediaSwitch(targetMediaId) {
    console.log('Manual media switch to:', targetMediaId);
    
    // Remove active from all media items
    const allMediaItems = document.querySelectorAll('.product__media-item');
    allMediaItems.forEach(item => {
      item.classList.remove('is-active');
    });
    
    // Add active to target media item
    const targetMediaItem = document.querySelector(`[data-media-id="${targetMediaId}"]`);
    if (targetMediaItem) {
      targetMediaItem.classList.add('is-active');
      console.log('Manually activated media item:', targetMediaId);
      
      // Also update thumbnails
      const allThumbnails = document.querySelectorAll('[data-target] button');
      allThumbnails.forEach(btn => {
        btn.removeAttribute('aria-current');
        btn.parentElement.classList.remove('is-active');
      });
      
      const targetThumbnail = document.querySelector(`[data-target="${targetMediaId}"]`);
      if (targetThumbnail) {
        const button = targetThumbnail.querySelector('button');
        if (button) {
          button.setAttribute('aria-current', 'true');
          targetThumbnail.classList.add('is-active');
        }
      }
    } else {
      console.log('Target media item not found:', targetMediaId);
    }
  }

  checkCartAddSuccess() {
    const successFlag = localStorage.getItem('cartAddSuccess');
    if (successFlag === 'true') {
      localStorage.removeItem('cartAddSuccess');
      this.showMessage('Added to cart successfully!', 'success');
    }
  }

  preventAutoScroll() {
    // More comprehensive scroll prevention following ChatGPT recommendation
    
    // 1. Override scrollIntoView temporarily during variant changes
    const originalScrollIntoView = Element.prototype.scrollIntoView;
    let preventScrolling = false;
    
    const blockScrollIntoView = () => {
      preventScrolling = true;
      Element.prototype.scrollIntoView = () => {}; // Block all scrollIntoView calls
      
      // Re-enable after a short delay
      setTimeout(() => {
        Element.prototype.scrollIntoView = originalScrollIntoView;
        preventScrolling = false;
      }, 500);
    };
    
    // 2. Prevent scroll on variant option changes (universal fix)
    document.querySelectorAll('[name="options"] select, [name="options"] input').forEach(el => {
      el.addEventListener('change', (e) => {
        blockScrollIntoView();
        
        // Prevent URL-based auto-scroll
        const url = new URL(window.location);
        url.searchParams.set(el.name, el.value);
        history.replaceState({}, '', url);
      });
    });
    
    // 3. Prevent scroll on our custom buttons
    const buttons = document.querySelectorAll('.size-btn, .print-type-btn, .lids-pill, .production-slider-mark');
    buttons.forEach(button => {
      button.addEventListener('click', (e) => {
        blockScrollIntoView();
        // Don't prevent default here as it would break functionality
      });
    });
    
    // 4. Intercept variant form changes
    const variantSelects = document.querySelector('variant-selects');
    if (variantSelects) {
      variantSelects.addEventListener('change', () => {
        blockScrollIntoView();
      });
    }
  }

  setupTooltips() {
    const tooltipIcons = document.querySelectorAll('.tooltip-icon[data-tooltip]');
    
    tooltipIcons.forEach(icon => {
      let tooltip = null;
      
      const showTooltip = (e) => {
        // Remove any existing tooltips
        document.querySelectorAll('.tooltip-popup').forEach(t => t.remove());
        
        const tooltipText = icon.getAttribute('data-tooltip');
        if (!tooltipText) return;
        
        // Create tooltip element
        tooltip = document.createElement('div');
        tooltip.className = 'tooltip-popup';
        tooltip.innerHTML = tooltipText;
        
        // Style the tooltip
        Object.assign(tooltip.style, {
          position: 'absolute',
          background: '#000000',
          color: '#ffffff',
          padding: '12px 16px',
          borderRadius: '6px',
          fontSize: '14px',
          fontWeight: '400',
          lineHeight: '1.4',
          maxWidth: '300px',
          width: 'auto',
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
          zIndex: '9999',
          opacity: '0',
          visibility: 'hidden',
          transition: 'all 0.2s ease',
          pointerEvents: 'none'
        });
        
        // Add to DOM - append to the icon's parent container for better positioning
        const container = icon.closest('.form__label') || icon.parentElement;
        container.style.position = 'relative';
        container.appendChild(tooltip);
        
        // Position tooltip relative to icon
        const iconRect = icon.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();
        
        // Get tooltip dimensions after adding to DOM
        tooltip.style.visibility = 'visible';
        tooltip.style.opacity = '0';
        const tooltipRect = tooltip.getBoundingClientRect();
        tooltip.style.visibility = 'hidden';
        
        // Calculate position relative to container
        const iconLeft = iconRect.left - containerRect.left;
        const iconTop = iconRect.top - containerRect.top;
        
        // Position above the icon, centered horizontally
        let left = iconLeft + (iconRect.width / 2) - (tooltipRect.width / 2);
        let top = iconTop - tooltipRect.height - 8;
        
        // Keep tooltip within viewport
        const viewportWidth = window.innerWidth;
        const tooltipLeftInViewport = containerRect.left + left;
        const tooltipRightInViewport = tooltipLeftInViewport + tooltipRect.width;
        
        // Adjust horizontal position if going off screen
        if (tooltipLeftInViewport < 10) {
          left = 10 - containerRect.left;
        } else if (tooltipRightInViewport > viewportWidth - 10) {
          left = (viewportWidth - 10 - containerRect.left) - tooltipRect.width;
        }
        
        // If no room above, show below
        if (containerRect.top + top < 10) {
          top = iconTop + iconRect.height + 8;
        }
        
        tooltip.style.left = left + 'px';
        tooltip.style.top = top + 'px';
        
        // Show tooltip
        requestAnimationFrame(() => {
          tooltip.style.opacity = '1';
          tooltip.style.visibility = 'visible';
        });
      };
      
      const hideTooltip = () => {
        if (tooltip) {
          tooltip.style.opacity = '0';
          tooltip.style.visibility = 'hidden';
          setTimeout(() => {
            if (tooltip && tooltip.parentNode) {
              tooltip.parentNode.removeChild(tooltip);
            }
            tooltip = null;
          }, 200);
        }
      };
      
      // Add event listeners
      icon.addEventListener('mouseenter', showTooltip);
      icon.addEventListener('mouseleave', hideTooltip);
      icon.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
      });
    });
    
         // Clean up tooltips on page interactions
     document.addEventListener('scroll', () => {
       document.querySelectorAll('.tooltip-popup').forEach(t => {
         if (t.parentNode) t.parentNode.removeChild(t);
       });
     });
     
     document.addEventListener('click', (e) => {
       if (!e.target.closest('.tooltip-icon')) {
         document.querySelectorAll('.tooltip-popup').forEach(t => {
           if (t.parentNode) t.parentNode.removeChild(t);
         });
       }
          });
  }
}

// Smooth scroll to shipping calculator function
function scrollToShippingCalculator(event) {
  event.preventDefault();
  
  const shippingCalculator = document.getElementById('shipping-calculator');
  if (shippingCalculator) {
    shippingCalculator.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}

// Smooth scroll to ETA calculator section function
function scrollToEtaCalculator(event) {
  event.preventDefault();
  
  const etaCalculatorSection = document.getElementById('eta-calculator-section');
  if (etaCalculatorSection) {
    etaCalculatorSection.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}

// Legacy function for backwards compatibility
function scrollToDesignUpload(event) {
  event.preventDefault();
  
  const designUploadSection = document.getElementById('design-upload-section');
  if (designUploadSection) {
    designUploadSection.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}

// Test function for toast notification
function testToast() {
  if (window.compostableDoubleWallProduct) {
    window.compostableDoubleWallProduct.showMessage('Test toast message!', 'success');
  } else {
    console.error('CompostableDoubleWallProduct not found');
  }
}

// Force bold function for dropdown titles
function forceBoldTitles() {
  console.log('Running forceBoldTitles...');
  
  // Find all dropdown titles
  const allTitles = document.querySelectorAll('.dropdown-title, .description-title');
  console.log('Found titles:', allTitles.length);
  
  allTitles.forEach((title, index) => {
    console.log(`Making title bold: ${title.textContent.trim()}`);
    
    // Use regular bold font-weight without text-shadow
    title.style.setProperty('font-weight', 'bold', 'important');
    title.classList.add('force-bold');
  });
  
  // NOW MAKE VARIANT SELECTOR TITLES BLACK
  const variantLabels = document.querySelectorAll('.form__label');
  console.log('Found variant labels:', variantLabels.length);
  
  variantLabels.forEach((label, index) => {
    console.log(`Making variant label black: ${label.textContent.trim()}`);
    label.style.setProperty('color', '#000000', 'important');
    label.style.setProperty('font-weight', 'bold', 'important');
  });
  
  // MAKE MAIN PRODUCT TITLE BLACK
  const mainProductTitle = document.querySelector('.product__title h1');
  if (mainProductTitle) {
    console.log(`Making main product title black: ${mainProductTitle.textContent.trim()}`);
    mainProductTitle.style.setProperty('color', '#000000', 'important');
  }
  
  // MAKE PRODUCT TAGLINE BLACK
  const productTagline = document.querySelector('.product-tagline');
  if (productTagline) {
    console.log(`Making product tagline black: ${productTagline.textContent.trim()}`);
    productTagline.style.setProperty('color', '#000000', 'important');
  }
  
  // Add CSS rule if it doesn't exist
  if (!document.querySelector('#force-bold-style')) {
    const style = document.createElement('style');
    style.id = 'force-bold-style';
    style.textContent = `
      .force-bold, .dropdown-title, .description-title {
        font-weight: 700 !important;
      }
      .form__label {
        color: #000000 !important;
        font-weight: bold !important;
      }
      .product__title h1 {
        color: #000000 !important;
      }
      .product-tagline {
        color: #000000 !important;
      }
    `;
    document.head.appendChild(style);
    console.log('Added force-bold CSS rule');
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const pricingTable = document.getElementById('quantity-grid-body');
  const sizeButtons = document.querySelectorAll('.size-btn');
  
  if (pricingTable && sizeButtons.length > 0) {
    window.compostableDoubleWallProduct = new CompostableDoubleWallProduct();
  }
});
